// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#invoice-create[data-v-e653ee52]  .form-group{margin-bottom:.25rem}#invoice-create[data-v-e653ee52]  .form-group label,#invoice-create[data-v-e653ee52]  .form-group legend{font-weight:600;margin-bottom:0;padding-bottom:0;font-size:1rem}", ""]);
// Exports
module.exports = exports;
